import { Flex, Spinner, Text, VStack } from "@chakra-ui/react"
import { Suspense } from "react"

interface LoadingSuspenseProps {
  children: React.ReactNode
  fallback?: React.ReactNode
  loadingText?: string
}

const DefaultFallback = ({
  loadingText = "Loading...",
}: { loadingText?: string }) => (
  <Flex
    height="400px"
    alignItems="center"
    justifyContent="center"
    direction="column"
  >
    <VStack gap={4}>
      <Spinner size="lg" />
      <Text fontSize="md" color="gray.600">
        {loadingText}
      </Text>
    </VStack>
  </Flex>
)

export const LoadingSuspense = ({
  children,
  fallback,
  loadingText,
}: LoadingSuspenseProps) => {
  return (
    <Suspense
      fallback={fallback || <DefaultFallback loadingText={loadingText} />}
    >
      {children}
    </Suspense>
  )
}

// Pre-configured suspense wrappers for common use cases
export const PageSuspense = ({ children }: { children: React.ReactNode }) => (
  <LoadingSuspense loadingText="Loading page...">{children}</LoadingSuspense>
)

export const FeatureSuspense = ({
  children,
}: { children: React.ReactNode }) => (
  <LoadingSuspense loadingText="Loading feature...">{children}</LoadingSuspense>
)

export const ComponentSuspense = ({
  children,
}: { children: React.ReactNode }) => (
  <LoadingSuspense loadingText="Loading component...">
    {children}
  </LoadingSuspense>
)
